import axiosInstance from "./http/axios_instance"
const http = axiosInstance("/public")

const getEmailFromToken = (token) => http.get("/user/" + token);

export default {
    getEmailFromToken
}